export const searchLogsConstants = {
    GET_SEARCH_LOG_DATA_REQUEST: 'GET_SEARCH_LOG_DATA_REQUEST',
    GET_SEARCH_LOG_DATA_SUCCESS: 'GET_SEARCH_LOG_DATA_SUCCESS',
    GET_SEARCH_LOG_DATA_FAILURE: 'GET_SEARCH_LOG_DATA_FAILURE',
}